export default __webpack_public_path__ + "assets/tablet-ordering.8aebc382.svg";